const Cookies = require('universal-cookie')

const cookies = new Cookies()

export default cookies
